import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ToastContainerComponent } from "@my-sport-app/cdk";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: "./app.html",
  styleUrl: "./app.css",
})
export class App {
}
